import { z } from "zod";

import { userSchema } from "../commons";

export const enterpriseTestimonialSchema = z.object({
  company: z.string(),
  logo: z.string().optional(),
  name: z.string(),
  title: z.string(),
  csat: z.number(),
  text: z.string(),
});

export const portfolioSchema = userSchema
  .pick({
    _id: true,
    name: true,
    preferredName: true,
    avatar: true,
    skills: true,
    specialties: true,
    highlights: true,
    level: true,
    bio: true,
    linkedIn: true,
    yearsExperience: true,
    topClients: true,
  })
  .required()
  .extend({
    bio: z.string().optional(),
    preferredName: z.string().optional(),
    // TODO: this should be a URL.
    linkedIn: z.string().optional(),
    // TODO: this should be a URL.
    website: z.string().optional(),
    yearsExperience: z.coerce.number().optional(),
    pronoun: z.string().optional(),
    topClients: z.string().optional(),
    isAvailable: z.boolean(),
    socialLinks: z.array(z.string()).optional(),
    testimonials: z.array(enterpriseTestimonialSchema),
  });

export type Portfolio = z.infer<typeof portfolioSchema>;

export const getPortfolioParamsSchema = z.object({
  portfolioId: z.string(),
});

export const getPortfolioRequestSchema = z.object({
  params: getPortfolioParamsSchema,
});

export type GetPortfolioRequest = z.infer<typeof getPortfolioRequestSchema>;

export type EnterpriseTestimonial = z.infer<typeof enterpriseTestimonialSchema>;

export type GetPortfolioResponse = z.infer<typeof portfolioSchema>;
